module.exports = __webpack_public_path__ + "static/media/phone-3.07c2b1f7.svg";